import React, { FC } from "react";

import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";

import { useIdleTimeout } from "../helpers/useIdleTimeout";

const styles = (theme: Theme) =>
  createStyles({
    idleWrapper: {
      display: "flex",
      flexDirection: "row",
      background: "#FFF9C4",
      position: "absolute",
      top: "70px",
      left: "100px",
      gap: "2rem",
      zIndex: 100,
      alignItems: "center",
      padding: "2rem",
      borderRadius: "0.5rem",
    },
    idleTextWrapper: {
      display: "flex",
      flexDirection: "column",
      fontSize: "19px",
      lineHeight: "0",
      margin: 0,
      gap: "1rem",
    },
  });

type IdleTimerProps = {} & WithStyles<typeof styles>;

const IdleTimerUnstyled: FC<IdleTimerProps> = ({ classes }) => {
  const { isIdle: isUserIdle, reset: resetTimer } = useIdleTimeout(60 * 5000);

  if (!isUserIdle) return <></>;

  return (
    <div className={classes.idleWrapper}>
      <div>
        <WarningIcon style={{ fontSize: "2rem", color: "orange" }} />
      </div>
      <div className={classes.idleTextWrapper}>
        <p style={{ margin: 0, marginTop: "5px", marginBottom: "5px" }}>Idle Warning</p>
        <p style={{ margin: 0, marginTop: "5px", marginBottom: "5px" }}>This page has been inactive for a while. Refresh to ensure the data is accurate.</p>
        <a href="#" onClick={() => window.location.reload()} style={{ marginTop: "0.5rem" }}>
          Refresh
        </a>
      </div>
      <div>
        <div onClick={() => resetTimer()}>
          <CloseIcon style={{ cursor: "pointer", fontSize: "2rem", color: "#000" }} />
        </div>
      </div>
    </div>
  );
};

export const IdleTimer = withStyles(styles)(IdleTimerUnstyled);
